import { render, staticRenderFns } from "./CategoryPicker.vue?vue&type=template&id=4f02c5a3&scoped=true"
import script from "./CategoryPicker.vue?vue&type=script&lang=js"
export * from "./CategoryPicker.vue?vue&type=script&lang=js"
import style0 from "./CategoryPicker.vue?vue&type=style&index=0&id=4f02c5a3&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f02c5a3",
  null
  
)

export default component.exports